var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';
const units = ['px', '%', 'em', 'rem', 'vw', 'vh'];
let SizeInput = class SizeInput extends Vue {
  unitChange(value) {
    if (['auto', 'none'].includes(value)) {
      this.$emit('change', value);
    } else {
      this.$emit('change', `${this.value}${value}`);
    }
  }
  render() {
    const h = arguments[0];
    return h("a-input", {
      "attrs": {
        "placeholder": this.placeholder,
        "size": "small",
        "value": this.value,
        "type": "number",
        "step": this.step
      },
      "on": {
        "change": e => this.$emit('change', `${e.target.value}${this.unit}`)
      }
    }, [['auto', 'none'].includes(this.value) ? null : h("a-select", {
      "attrs": {
        "disabled": this.fixedUnit,
        "defaultValue": this.unit,
        "size": "small"
      },
      "slot": "addonAfter",
      "on": {
        "change": this.unitChange
      }
    }, [units.concat(this.extraUnits || []).map(unit => h("a-select-option", {
      "attrs": {
        "value": unit
      }
    }, [unit]))])]);
  }
};
__decorate([Prop({
  type: String,
  default: 'px'
})], SizeInput.prototype, "unit", void 0);
__decorate([Prop({
  type: Array,
  default: () => []
})], SizeInput.prototype, "extraUnits", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], SizeInput.prototype, "value", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], SizeInput.prototype, "placeholder", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], SizeInput.prototype, "fixedUnit", void 0);
__decorate([Prop({
  type: Number,
  default: 1
})], SizeInput.prototype, "step", void 0);
SizeInput = __decorate([Component({
  name: 'SizeInput',
  model: {
    prop: 'value',
    event: 'change'
  }
})], SizeInput);
export default SizeInput;
//# sourceMappingURL=sizeInput.js.map
